export const measurementDefinitions = {
  altCurrentLimit: {
    usage: 'Config',
    format: 'Number',
    friendlyName: 'Current Limit',
    units: 'Amps',
    active: true,
    notes: null,
  },
  ampHrCapacity: {
    usage: 'Config',
    format: 'Number',
    friendlyName: 'Amp Hour Capacity',
    units: 'Ah',
    active: true,
    notes: null,
  },
  cRate: {
    usage: 'Config',
    format: 'Number',
    friendlyName: 'Maximum Charging C-Rate',
    units: '%',
    active: true,
    notes: null,
  },
  'cv.Volts': {
    usage: 'Config',
    format: 'Number',
    friendlyName: 'Bulk/Absorb Stage Voltage',
    units: 'Volts',
    active: true,
    notes: null,
  },
  desiredAmps: {
    usage: 'Config',
    format: 'Number',
    friendlyName: 'CAN bus Target Current',
    units: 'Amps',
    active: true,
    notes: null,
  },
  desiredVolts: {
    usage: 'Config',
    format: 'Number',
    friendlyName: 'CAN bus Target Voltage',
    units: 'Volts',
    active: true,
    notes: null,
  },
  'float.Volts': {
    usage: 'Config',
    format: 'Number',
    friendlyName: 'Float Stage Voltage',
    units: 'Volts',
    active: true,
    notes: null,
  },
  'postCv.Volts': {
    usage: 'Config',
    format: 'Number',
    friendlyName: 'Additional Absorb Stage Voltage',
    units: 'Volts',
    active: true,
    notes: null,
  },
  targetTemp: {
    usage: 'Config',
    format: 'Number',
    friendlyName: 'Target Temperature',
    units: '°C',
    active: true,
    notes: null,
  },
  amps: {
    usage: 'Metric',
    format: 'Number',
    friendlyName: 'Current',
    units: 'Amps',
    active: true,
    notes: null,
  },
  engineLoad: {
    usage: 'Metric',
    format: 'Number',
    friendlyName: 'Engine Load',
    units: '%',
    active: true,
    notes: null,
  },
  field: {
    usage: 'Metric',
    format: 'Number',
    friendlyName: 'Field Power',
    units: '%',
    active: true,
    notes: null,
  },
  motorRpm: {
    usage: 'Metric',
    format: 'Number',
    friendlyName: 'Engine RPM',
    units: 'RPM',
    active: true,
    notes: null,
  },
  soc: {
    usage: 'Metric',
    format: 'Number',
    friendlyName: 'State of Charge',
    units: '%',
    active: true,
    notes: null,
  },
  temp: {
    usage: 'Metric',
    format: 'Number',
    friendlyName: 'Temperature',
    units: '°C',
    active: true,
    notes: null,
  },
  volts: {
    usage: 'Metric',
    format: 'Number',
    friendlyName: 'Voltage',
    units: 'Volts',
    active: true,
    notes: null,
  },
  batConnected: {
    usage: 'Status',
    format: 'Number',
    friendlyName: 'Battery Connected Status',
    units: null,
    active: false,
    notes: null,
  },
  boostEngaged: {
    usage: 'Status',
    format: 'Number',
    friendlyName: 'Boost Mode Active',
    units: null,
    active: true,
    notes: 'Any value means Yes, absence of value means No',
  },
  canbusConnected: {
    usage: 'Status',
    format: 'Number',
    friendlyName: 'CAN bus Connected Status',
    units: null,
    active: true,
    notes: '1 means Yes, otherwise No',
  },
  chargeStage: {
    usage: 'Status',
    format: 'Text',
    friendlyName: 'Charge Stage',
    units: null,
    active: true,
    notes: 'cv = Bulk / Absorb, postCv = Second Absorb, float = Float',
  },
  combinedChargeCutoff: {
    usage: 'Status',
    format: 'Number',
    friendlyName: 'Charge Cutoff Status',
    units: null,
    active: true,
    notes: '1 means Yes, otherwise No',
  },
}
